/* A-Ljus product page: add the ticked light source ("Komplettera med ljuskälla") together with the lamp. */
(() => {
  if (window.aljusUpsellBound) return;
  window.aljusUpsellBound = true;

  let passThrough = false;

  // Capture phase: runs before Dawn's product-form submit handler.
  document.addEventListener(
    'click',
    async (event) => {
      if (passThrough) return;

      const button = event.target.closest('button[name="add"]');
      if (!button || !button.form || button.disabled) return;

      // Only the main product's own button (accessory rows etc. have their own forms)
      const container = button.closest('product-info');
      if (!container) return;
      const upsell = container.querySelector('[data-aljus-upsell]:checked');
      if (!upsell) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      button.setAttribute('aria-busy', 'true');

      try {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(upsell.value), quantity: 1 }] }),
        });
        upsell.checked = false;
      } catch (error) {
        // If the light source can't be added, still add the lamp.
      }

      button.removeAttribute('aria-busy');
      // Let Dawn add the lamp; its cart drawer/notification then shows both items.
      passThrough = true;
      button.click();
      passThrough = false;
    },
    true
  );
})();
